import React from 'react';
import classNames from 'classnames';
import { isNil } from 'lodash';
import { usePopoverContext } from '../PopoverContext';
import { PopoverChevronProps } from '../types';
import classes from './index.module.scss';

const PopoverChevron = ({ size = 'md', dataTestId }: PopoverChevronProps) => {
  const {
    arrowRef,
    floatingData: {
      middlewareData: { arrow },
      placement,
    },
  } = usePopoverContext();
  const arrowOffset = arrowRef?.current?.offsetWidth || 0;
  const side = placement.split('-')[0];
  const staticSide = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
  }[side] as string;

  return (
    <div
      data-testid={dataTestId}
      ref={arrowRef}
      className={classNames(classes.chevron, { [classes.sizeSm]: size === 'sm' })}
      style={{
        left: isNil(arrow?.x) ? '' : `${arrow?.x}px`,
        top: isNil(arrow?.y) ? '' : `${arrow?.y}px`,
        right: '',
        bottom: '',
        [staticSide]: `${-arrowOffset / 2}px`,
      }}
    />
  );
};

PopoverChevron.displayName = 'PopoverChevron';

export default PopoverChevron;
